import React, { Fragment } from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Up } from "./PositionFade";
import { UpInView } from "./PositionFadeInView";
import { useNavigate } from "react-router";

export default function Footer(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 600, 1200, 1800, 2400];
  const timelineDelays2 = [100, 200, 300, 400];
  const timelineDelays3 = [700, 800, 900];

  const timelineDelays4 = [1300, 1400, 1500];
  const timelineDelays5 = [1900];
  const navigate = useNavigate();

  return (
    <div
      className="footer anigrad"
      style={{ backgroundColor: "white", marginTop: "50px", maxWidth: "100vw" }}
    >
      <div style={{ height: "50px" }}></div>
      <div
        style={{
          margin: "0px 50px 0px 50px",
          borderRadius: "25px",
          backgroundColor: "white",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          background:
            "linear-gradient(0deg, rgba(0,0,0,0.0), rgba(2, 77, 194, 0.0), rgba(2, 77, 194, 0.0)), url('https://images.unsplash.com/photo-1582738411706-bfc8e691d1c2?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      >
        <Grid
          container
          style={{
            borderRadius: "50px",
            padding: state.auth.isMobile ? "20px" : "100px",
            backdropFilter: "blur(10px)",
            minHeight: "30vh",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={9}
            lg={9}
            xl={9}
            style={{ marginTop: "-25px" }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                textAlign: "left",
              }}
            >
              {state.auth.isMobile}
              Ready to discuss projects with us?
            </div>
            <div
              style={{
                fontSize: "22px",
                color: "black",
                textAlign: "left",
              }}
            >
              Get in touch with us and we can get you the best product
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            xl={3}
            style={{ marginTop: state.auth.isMobile ? "50px" : "-25px" }}
          >
            <div class="button-box" onClick={() => navigate("/contact")}>
              <button class="ten">Contact Us</button>
            </div>
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          minHeight: "60vh",
          width: "100vw",
          padding: "100px 0px 100px 25px",
        }}
      >
        <Grid container>
          <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
            <Grid container spacing={5}>
              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <UpInView delay={timelineDelays[1]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    India
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 50px 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: "white",
                  }}
                ></div>
                <UpInView delay={timelineDelays3[0]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    226, 1st Floor, 100 Feet Rd, HRBR Layout, Banaswadi,
                    Bengaluru, Karnataka 560043
                  </div>
                </UpInView>

                <br />
                <UpInView delay={timelineDelays3[2]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <EmailIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    hr@cgtsol.com
                  </div>
                </UpInView>
                <br />
                {/* <UpInView delay={timelineDelays[0]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CGT Solutions
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 50px 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: "white",
                  }}
                ></div>
                <UpInView delay={timelineDelays2[0]}>
                  <div
                    onClick={() => navigate("/about")}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    About Us
                  </div>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[1]}>
                  <div
                    onClick={() => navigate("/contact")}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Contact Us
                  </div>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[2]}>
                  <div
                    onClick={() => navigate("/careers")}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Careers
                  </div>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <div
                    onClick={() => navigate("/")}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Home
                  </div>
                </UpInView>
              </Grid>
              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              > */}
                {/* <UpInView delay={timelineDelays[1]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    India
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 50px 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: "white",
                  }}
                ></div>
                <UpInView delay={timelineDelays3[0]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    226, 1st Floor, 100 Feet Rd, HRBR Layout, Banaswadi,
                    Bengaluru, Karnataka 560043
                  </div>
                </UpInView>

                <br />
                <UpInView delay={timelineDelays3[2]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <EmailIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    hr@cgtsol.com
                  </div>
                </UpInView>
                <br /> */}
              </Grid>
              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                {" "}
                <UpInView delay={timelineDelays[2]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    USA
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 50px 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: "white",
                  }}
                ></div>
                <UpInView delay={timelineDelays4[0]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    Sole MBR 7024, Encore Way Roseville, CA 95747
                  </div>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays4[2]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <PhoneInTalkIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    +91 9686945846 / +1 (442) 223-0040
                  </div>
                </UpInView>
                <br />
              </Grid>

              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <UpInView delay={timelineDelays[3]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    South Africa
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 50px 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: "white",
                  }}
                ></div>
                <UpInView delay={timelineDelays5[0]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    155, West Street Sandton, Johannesburg, GP 2031
                  </div>
                </UpInView>
                <br />
                {/* <UpInView delay={timelineDelays[3]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    United Kingdom
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 50px 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: "white",
                  }}
                ></div>
                <UpInView delay={timelineDelays5[0]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    Kemp House 152-160, City Road, London EC1V 2NX
                  </div>
                </UpInView>
                <br /> */}
              </Grid>
              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                {" "}
                <UpInView delay={timelineDelays[3]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    United Kingdom
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 50px 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: "white",
                  }}
                ></div>
                <UpInView delay={timelineDelays4[0]}>
                  <div
                    style={{
                      fontSize: "16px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    Kemp House 152-160, City Road, London EC1V 2NX
                    </div>
                </UpInView>
                <br />
               
                <br />
              </Grid>
            </Grid>
            
            <br />
            <Grid container spacing={5}>
              <Grid
                item
                md={3}
                sm={12}
                xs={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CopyrightIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  2025 CGT Solutions
                </div>
              </Grid>
              <Grid
                item
                md={6}
                sm={12}
                xs={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    borderRadius: "25px",
                    width: "50%",
                    height: "50px",
                    fontSize: "26px",
                    color: "white",
                    fontWeight: 600,
                  }}
                >
                  CGT Solutions
                </div>
              </Grid>
              <Grid
                item
                md={3}
                sm={12}
                xs={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div style={{ display: "flex" }}>
                  <div
                    onClick={() =>
                      window.open("https://x.com/cgt_tweets", "_blank")
                    }
                    style={{
                      border: "1px white solid",
                      borderRadius: "40px",
                      width: "50px",
                      height: "50px",
                      fontSize: "16px",
                      color: "white",
                      marginRight: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <XIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div
                    onClick={() =>
                      window.open(
                        "https://in.linkedin.com/company/cgtsolutions",
                        "_blank"
                      )
                    }
                    style={{
                      border: "1px white solid",
                      borderRadius: "40px",
                      width: "50px",
                      height: "50px",
                      fontSize: "16px",
                      color: "white",
                      marginRight: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LinkedInIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        cursor: "pointer",
                      }}
                    />
                  </div>

                  <div
                    onClick={() =>
                      window.open(
                        "https://www.facebook.com/cgtsol?_rdr",
                        "_blank"
                      )
                    }
                    style={{
                      border: "1px white solid",
                      borderRadius: "40px",
                      width: "50px",
                      height: "50px",
                      fontSize: "16px",
                      color: "white",
                      marginRight: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FacebookIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/cgtsolutions/",
                        "_blank"
                      )
                    }
                    style={{
                      border: "1px white solid",
                      borderRadius: "40px",
                      width: "50px",
                      height: "50px",
                      fontSize: "16px",
                      color: "white",
                      marginRight: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <InstagramIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        </Grid>
      </div>
    </div>
  );
}
